type ScreenOrientationApi = {
  lock?: (orientation: string) => Promise<void> | undefined;
  unlock?: () => void;
};

const getScreenOrientation = (): ScreenOrientationApi | undefined => {
  if (typeof window === 'undefined') return undefined;
  return window.screen?.orientation as unknown as ScreenOrientationApi | undefined;
};

//  screen.orientation.lock() returns a Promise that rejects with NotSupportedError on devices
//  that do not implement it, and with AbortError when a later lock()/unlock() supersedes the
//  call. Neither is a real failure, but an unhandled rejection is picked up by Sentry's global
//  handler and reported as an error — the source of CAMILA-CSR-16 and CAMILA-CSR-5F0000000003N.
//  Feature-detect, then swallow the rejection.
export const lockOrientation = (orientation = 'landscape'): void => {
  getScreenOrientation()?.lock?.(orientation)?.catch(() => undefined);
};

export const unlockOrientation = (): void => {
  getScreenOrientation()?.unlock?.();
};
